import {

  useState

} from "react";

import {

  useAuth

} from "../context/AuthContext";

import ReactDOM from "react-dom";

export default function AuthModal({

  onClose,
  onSuccess

}) {

  const {

    login,
    register

  } = useAuth();

  const [mode, setMode] =
    useState("login");

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const [successMessage, setSuccessMessage] =
    useState("");

  const [form, setForm] =
    useState({

      email: "",
      password: "",

      username: "",

      display_name: "",

      default_aircraft: "",

      home_airport: ""
    });

  const updateField = (
    key,
    value
  ) => {

    setForm(prev => ({

      ...prev,

      [key]: value
    }));
  };

  const inputStyle = {

    background:
      "rgba(255,255,255,0.06)",

    border:
      "1px solid rgba(255,255,255,0.12)",

    borderRadius: "8px",

    padding: "12px",

    color: "white",

    outline: "none",

    fontSize: "14px"
  };

  const primaryButton = {

    background:
      "linear-gradient(180deg,#3b82f6,#2563eb)",

    border: "none",

    borderRadius: "8px",

    color: "white",

    padding: "12px",

    fontWeight: "600",

    cursor: "pointer",

    fontSize: "14px"
  };

  const secondaryButton = {

    background:
      "rgba(255,255,255,0.06)",

    border:
      "1px solid rgba(255,255,255,0.12)",

    borderRadius: "8px",

    color: "white",

    padding: "12px",

    cursor: "pointer",

    fontSize: "14px"
  };

  const handleSubmit =
    async () => {

      try {

        setLoading(true);

        setError("");
        setSuccessMessage("");

        if (mode === "login") {

          await login(
            form.email,
            form.password
          );

          onSuccess?.();
          onClose?.();

        } else {

          const result =
            await register(form);

          if (
            result?.verification_required
          ) {

            setSuccessMessage(
              result.message ||
              "Account created. Please check your email to verify your account."
            );

            return;
          }

          setSuccessMessage(
            result?.message ||
            "Account created successfully."
          );
        }

      } catch (err) {

        console.error(err);

        setError(
          err.message
        );

      } finally {

        setLoading(false);
      }
    };

return ReactDOM.createPortal(


    <div style={{
position: "fixed",

inset: 0,

display: "flex",

justifyContent: "center",

alignItems: "center",

background: "rgba(0,0,0,0.72)",

backdropFilter: "blur(10px)",

zIndex: 99999999,

    }}>

      <div style={{

        width: "460px",

        position: "relative",

   

        background:
          "linear-gradient(180deg,#1c1f24 0%,#13161a 100%)",

        borderRadius: "16px",

        padding: "28px",

        color: "white",

        border:
          "1px solid rgba(255,255,255,0.12)",

        boxShadow:
          "0 0 40px rgba(0,0,0,0.55)"
      }}>

        {/* HEADER */}

        <div style={{

          marginBottom: "24px"
        }}>

          <div style={{

            fontSize: "24px",

            fontWeight: "700",

            marginBottom: "10px"
          }}>

            🔐 Operational Airport Intelligence

          </div>

          <div style={{

            color:
              "rgba(255,255,255,0.75)",

            lineHeight: "1.5",

            fontSize: "14px"
          }}>

            Advanced operational airport features
            require a FICON-X operational account.

          </div>

          <div style={{

            marginTop: "16px",

            fontSize: "13px",

            color: "#8ec5ff",

            lineHeight: "1.8"
          }}>

            • Runway operational overlays<br/>
            • Taxiway restriction intelligence<br/>
            • FICON surface condition awareness<br/>
            • Shared crew missions<br/>
            • Real-time operational synchronization

          </div>

        </div>

        {/* FORM */}

        <div style={{

          display: "flex",

          flexDirection: "column",

          gap: "12px"
        }}>

          <input
            style={inputStyle}

            placeholder="Email"

            value={form.email}

            onChange={(e) =>
              updateField(
                "email",
                e.target.value
              )
            }
          />

          <input
            style={inputStyle}

            type="password"

            placeholder="Password"

            value={form.password}

            onChange={(e) =>
              updateField(
                "password",
                e.target.value
              )
            }
          />

          {mode === "register" && (

            <>

              <input
                style={inputStyle}

                placeholder="Username"

                value={form.username}

                onChange={(e) =>
                  updateField(
                    "username",
                    e.target.value
                  )
                }
              />

              <input
                style={inputStyle}

                placeholder="Display Name"

                value={form.display_name}

                onChange={(e) =>
                  updateField(
                    "display_name",
                    e.target.value
                  )
                }
              />

              <input
                style={inputStyle}

                placeholder="Default Aircraft"

                value={form.default_aircraft}

                onChange={(e) =>
                  updateField(
                    "default_aircraft",
                    e.target.value
                  )
                }
              />

              <input
                style={inputStyle}

                placeholder="Home Airport"

                value={form.home_airport}

                onChange={(e) =>
                  updateField(
                    "home_airport",
                    e.target.value
                  )
                }
              />

            </>
          )}

          {successMessage && (

            <div style={{

              color: "#7dd3a7",

              fontSize: "13px",

              lineHeight: "1.5",

              padding: "10px",

              border:
                "1px solid rgba(125,211,167,0.35)",

              borderRadius: "8px"
            }}>

              {successMessage}

            </div>
          )}

          {error && (

            <div style={{

              color: "#ff6b6b",

              fontSize: "13px"
            }}>

              {error}

            </div>
          )}

          {/* PRIMARY ACTION */}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={primaryButton}
          >

            {loading
              ? "Loading..."
              : mode === "login"
                ? "Login"
                : "Create Account"}

          </button>

          {/* MODE SWITCH */}

          <button
            onClick={() =>
              setMode(
                mode === "login"
                  ? "register"
                  : "login"
              )
            }

            style={secondaryButton}
          >

            {mode === "login"
              ? "Create Operational Account"
              : "Back to Login"}

          </button>

          {/* CLOSE */}

          <button
            onClick={onClose}

            style={{

              background: "transparent",

              border: "none",

              color:
                "rgba(255,255,255,0.55)",

              cursor: "pointer",

              marginTop: "4px",

              fontSize: "13px"
            }}
          >

            Continue Exploring

          </button>

        </div>

      </div>

    </div>,

    document.getElementById("modal-root")

  );
}